<template>
  <div class="profile-page">
    <div class="container py-4">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="card shadow">
            <div class="card-header bg-primary text-white">
              <h3 class="mb-0">User Profile</h3>
            </div>
            <div class="card-body">
              <div v-if="!isAuthenticated" class="text-center py-5">
                <div class="alert alert-warning" role="alert">
                  <i class="bi bi-exclamation-triangle-fill me-2"></i>
                  You are not logged in. Please <router-link to="/login" class="alert-link">login</router-link> to view your profile.
                </div>
              </div>
              
              <div v-else>
                <div class="row mb-4">
                  <div class="col-md-3 fw-bold">Email:</div>
                  <div class="col-md-9">{{ user.email }}</div>
                </div>
                
                <div class="row mb-4" v-if="user.id">
                  <div class="col-md-3 fw-bold">User ID:</div>
                  <div class="col-md-9">
                    <code>{{ user.id }}</code>
                  </div>
                </div>
                
                <div class="row mb-4" v-if="user.exp">
                  <div class="col-md-3 fw-bold">Token Expires:</div>
                  <div class="col-md-9">{{ formatExpiration(user.exp) }}</div>
                </div>
                
                <div class="row mb-4">
                  <div class="col-md-3 fw-bold">JWT Token:</div>
                  <div class="col-md-9">
                    <div class="token-display">
                      <button 
                        class="btn btn-sm btn-outline-secondary mb-2" 
                        @click="showToken = !showToken"
                      >
                        {{ showToken ? 'Hide Token' : 'Show Token' }}
                      </button>
                      <pre v-if="showToken" class="token-pre">{{ token }}</pre>
                      <div v-else class="text-muted fst-italic">
                        (Token hidden for security)
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="row mb-4" v-if="decodedToken">
                  <div class="col-md-3 fw-bold">Decoded Token:</div>
                  <div class="col-md-9">
                    <button 
                      class="btn btn-sm btn-outline-secondary mb-2" 
                      @click="showDecodedToken = !showDecodedToken"
                    >
                      {{ showDecodedToken ? 'Hide Decoded Token' : 'Show Decoded Token' }}
                    </button>
                    <pre v-if="showDecodedToken" class="token-pre">{{ decodedToken }}</pre>
                  </div>
                </div>
                
                <div class="d-grid gap-2 mt-4">
                  <button class="btn btn-danger" @click="handleLogout">
                    <i class="bi bi-box-arrow-right me-2"></i>Logout
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'ProfileView',
  data() {
    return {
      showToken: false,
      showDecodedToken: false,
      decodedToken: null
    };
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'currentUser']),
    user() {
      return this.currentUser || {};
    },
    token() {
      return 'HttpOnly - Not accessible via JavaScript';
    }
  },
  methods: {
    ...mapActions(['logout']),
    handleLogout() {
      this.logout();
      this.$router.push('/login');
    },
    formatExpiration(timestamp) {
      if (!timestamp) return 'Unknown';
      
      const expirationDate = new Date(timestamp * 1000);
      const now = new Date();
      
      // Calculate time difference
      const diffMs = expirationDate - now;
      const diffHrs = Math.floor(diffMs / (1000 * 60 * 60));
      const diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
      
      if (diffMs <= 0) {
        return 'Expired';
      }
      
      return `${expirationDate.toLocaleString()} (${diffHrs}h ${diffMins}m remaining)`;
    },
    decodeToken() {
      // With HttpOnly cookies, we can't access the token directly
      this.decodedToken = 'The JWT token is stored in an HttpOnly cookie and cannot be accessed via JavaScript. This is a security feature that protects the token from XSS attacks.';
    }
  },
  mounted() {
    this.decodeToken();
  }
};
</script>

<style scoped>
.token-pre {
  background-color: #f8f9fa;
  padding: 1rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  overflow-x: auto;
  white-space: pre-wrap;
  word-break: break-all;
  max-height: 200px;
  overflow-y: auto;
}
</style>
